module.exports = __webpack_public_path__ + "static/media/gender-specific.07feb6df.svg";